import { render, staticRenderFns } from "./CentrosMunicipales.vue?vue&type=template&id=4210e592&scoped=true&lang=pug&"
import script from "./CentrosMunicipales.vue?vue&type=script&lang=js&"
export * from "./CentrosMunicipales.vue?vue&type=script&lang=js&"
import style0 from "./CentrosMunicipales.vue?vue&type=style&index=0&id=4210e592&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210e592",
  null
  
)

export default component.exports